export default "__VITE_ASSET__lNTWjaU6__"